<script lang="ts">
import { defineComponent, h } from 'vue';

import { makeTagProps } from '../../composable';

import { makeGridProps, useGrid } from './composable';

export const componentName = 'CdsRow';
export default defineComponent({
  name: componentName,
  props: {
    ...makeTagProps(),
    ...makeGridProps()
  },
  setup(props, context) {
    const { prefix } = useGrid();

    return () =>
      h(
        props.tag,
        {
          class: {
            [`${prefix}-row`]: true,
            [`${prefix}-row-condensed`]: props.condensed,
            [`${prefix}-row-narrow`]: props.narrow
          }
        },
        context.slots.default && context.slots.default()
      );
  }
});
</script>
